document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tabs-nav__item').forEach(btn => {
    btn.addEventListener('click', () => {
      const section = btn.closest('.shopify-section--tabbed-collections');
      const target = btn.getAttribute('data-tab');

      // Atualiza botões
      section
        .querySelectorAll('.tabs-nav__item')
        .forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      // Atualiza painéis
      section
        .querySelectorAll('.tabs-nav__pane')
        .forEach(p => {
          p.classList.toggle('is-active', p.getAttribute('data-content') === target);
        });
    });
  });
});